import React from 'react';
import PropTypes from 'prop-types';
import query from './query.graphql';
import OtherResponseTable from '../OtherResponseTable';

const OtherGenderIdentity = props => {
    return (
        <OtherResponseTable
            filters={props.filters}
            settings={props.settings}
            query={query}
            field="specifyGender"
            table={props.table}
            groupLevel={props.groupLevel}
        />
    );
};

OtherGenderIdentity.propTypes = {
    filters: PropTypes.object,
    table: PropTypes.object,
    settings: PropTypes.object,
    groupLevel: PropTypes.string,
};

export default OtherGenderIdentity;
